// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-panel {
    display: flex;
    flex: 1 1; /* más ancho */
    flex-direction: column;
    align-items: center;
    width: 70%;
    padding: 12px 16px 0 12px;
    background-color: #111;
    border-bottom: 1px solid #222;
    color: white;
}

.chat-panel__header {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 12px 16px;
    border-bottom: 1px solid #222;
    background-color: #0a0a0a;
}

.chat-panel__header img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 12px;
}

.chat-panel__header span {
    font-weight: 500;
    font-size: 16px;
}

.chat-messages {
    flex: 1 1;
    padding: 16px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 10px;
    background: #000;
    width: 100%;
}

.chat-bubble {
    max-width: 70%;
    padding: 10px 14px;
    border-radius: 20px;
    font-size: 14px;
    line-height: 1.4;
    word-wrap: break-word;
}

.from-me {
    align-self: flex-end;
    background-color: #00c853;
    color: black;
    border-bottom-right-radius: 4px;
}

.from-them {
    align-self: flex-start;
    background-color: #1e1e1e;
    border-bottom-left-radius: 4px;
}

.chat-input {
    display: flex;
    width: 100%;
    padding: 12px 16px;
    justify-content: flex-start;
    gap: 16px;
    background-color: #2A2A2A;
    border-top: 1px solid #222;
}

.chat-input input {
    flex: 1 1;
    padding: 10px;
    background: transparent;
    border: none;
    color: white;
    border-radius: 20px;
    outline: none;
}

.chat-input button {
    background: #00e676;
    color: white;
    font-weight: bold;
    border: none;
    padding: 10px 16px;
    margin-left: 8px;
    border-radius: 20px;
    cursor: pointer;
}

.close-button {
    position: absolute;
    top: 25px;
    right: 30px;
    font-size: 20px;
    font-weight: bold;
    background: none;
    color: white;
    border: solid 3px;
    border-radius: 50%;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/styles/chat_panel.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAO,EAAE,cAAc;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,yBAAyB;IACzB,sBAAsB;IACtB,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,2BAA2B;IAC3B,SAAS;IACT,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,SAAO;IACP,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB","sourcesContent":[".chat-panel {\n    display: flex;\n    flex: 1; /* más ancho */\n    flex-direction: column;\n    align-items: center;\n    width: 70%;\n    padding: 12px 16px 0 12px;\n    background-color: #111;\n    border-bottom: 1px solid #222;\n    color: white;\n}\n\n.chat-panel__header {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    padding: 12px 16px;\n    border-bottom: 1px solid #222;\n    background-color: #0a0a0a;\n}\n\n.chat-panel__header img {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    object-fit: cover;\n    margin-right: 12px;\n}\n\n.chat-panel__header span {\n    font-weight: 500;\n    font-size: 16px;\n}\n\n.chat-messages {\n    flex: 1;\n    padding: 16px;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    background: #000;\n    width: 100%;\n}\n\n.chat-bubble {\n    max-width: 70%;\n    padding: 10px 14px;\n    border-radius: 20px;\n    font-size: 14px;\n    line-height: 1.4;\n    word-wrap: break-word;\n}\n\n.from-me {\n    align-self: flex-end;\n    background-color: #00c853;\n    color: black;\n    border-bottom-right-radius: 4px;\n}\n\n.from-them {\n    align-self: flex-start;\n    background-color: #1e1e1e;\n    border-bottom-left-radius: 4px;\n}\n\n.chat-input {\n    display: flex;\n    width: 100%;\n    padding: 12px 16px;\n    justify-content: flex-start;\n    gap: 16px;\n    background-color: #2A2A2A;\n    border-top: 1px solid #222;\n}\n\n.chat-input input {\n    flex: 1;\n    padding: 10px;\n    background: transparent;\n    border: none;\n    color: white;\n    border-radius: 20px;\n    outline: none;\n}\n\n.chat-input button {\n    background: #00e676;\n    color: white;\n    font-weight: bold;\n    border: none;\n    padding: 10px 16px;\n    margin-left: 8px;\n    border-radius: 20px;\n    cursor: pointer;\n}\n\n.close-button {\n    position: absolute;\n    top: 25px;\n    right: 30px;\n    font-size: 20px;\n    font-weight: bold;\n    background: none;\n    color: white;\n    border: solid 3px;\n    border-radius: 50%;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
